import { Component, Input, OnInit } from '@angular/core';
import { ICountry } from '../../../core/models/country.interface';
import { ConstantService } from '../../../core/services/constant.service';
import { PartnerService } from '../../../modules/partner-management/services/partner.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NotificationService } from '../../../core/services/notification.service';
import { ICompany } from '../../../modules/customer-registration/models/company.model';

import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';

import * as _moment from 'moment';
import { Moment } from 'moment';
import { ReportedTaxReportService } from '../../../core/services/reported-tax-report.service';
import { ConfirmPopupDialog } from '../../popups/confirm-popup/confirm-popup.component';
import { TaxReportType } from '../../enums/tax-report-type.enum';
import { reportQuarter } from '../../enums/quarter.enum';
import { CompanyService } from '../../../core/services/company.service';

const moment = _moment;

export const MONTH_YEAR_FORMATS = {
  parse: { dateInput: 'MM/YYYY' },
  display: {
    dateInput: 'MMM YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'eci-add-tax-report',
  templateUrl: './add-tax-report.component.html',
  styleUrls: ['./add-tax-report.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MONTH_YEAR_FORMATS },
  ],
})
export class AddTaxReportComponent implements OnInit {
  @Input() reportType!: number;

  addReportForm!: FormGroup;
  partnerId = '';
  selectedFileName: string = '';
  showLoader: boolean = false;
  message: string = '';
  btnText: 'Upload' | 'Replace' = 'Upload';

  searchCountry: FormControl = new FormControl('');
  searchPartner: FormControl = new FormControl('');
  searchCustomer: FormControl = new FormControl('');

  fullCountriesList: ICountry[] = [];
  partnerList: any[] = [];
  companyList: ICompany[] = [];
  availableYears: number[] = [];

  previousPageCompany = 0;
  totalPageCompany = 1;

  ReportTypeEnum = TaxReportType;
  reportQuarterEnum = reportQuarter;
  quarters = Object.keys(this.reportQuarterEnum)
  .filter(k => isNaN(Number(k)));

  constructor(
    private constSvc: ConstantService,
    private partnerService: PartnerService,
    private companyService: CompanyService,
    private dialogRef: MatDialogRef<AddTaxReportComponent>,
    private formBuilder: FormBuilder,
    private notify: NotificationService,
    private reportedTaxReportService: ReportedTaxReportService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.initializeForm();
    this.getListOfCountries();
    this.getPartnerList();
    this.getCompanyList();
    this.generateYearList();

    this.addReportForm.get('partner')?.valueChanges.subscribe((value) => {
      this.previousPageCompany = 0;
      this.totalPageCompany = 1;
      this.companyList = [];
      this.partnerId = value || '';
      this.getPartnerCompanyList(1);
    });

    // Frequency switcher
    // this.addReportForm.get('frequency')?.valueChanges.subscribe((freq) => {
    //   if (freq === 'monthly') {
    //     this.addReportForm
    //       .get('monthYear')
    //       ?.setValidators([Validators.required]);
    //     this.addReportForm.get('quarter')?.clearValidators();
    //     this.addReportForm.get('year')?.clearValidators();
    //   } else if (freq === 'quarterly') {
    //     this.addReportForm.get('monthYear')?.clearValidators();
    //     this.addReportForm
    //       .get('quarter')
    //       ?.setValidators([Validators.required]);
    //     this.addReportForm.get('year')?.setValidators([Validators.required]);
    //   }
    //   this.addReportForm.get('monthYear')?.updateValueAndValidity();
    //   this.addReportForm.get('quarter')?.updateValueAndValidity();
    //   this.addReportForm.get('year')?.updateValueAndValidity();
    // });
   console.log('reportType', this.reportType);
  }

  initializeForm() {
    this.addReportForm = this.formBuilder.group({
      partner: [''],
      customer: ['', Validators.required],
      country:
        this.reportType == TaxReportType.Regular || this.reportType == TaxReportType.Purchases
          ? ['', Validators.required]
          : [''],
      monthYear: this.reportType == TaxReportType.Regular
      || this.reportType == TaxReportType.Purchases
      || this.reportType == TaxReportType.IOSS ? ['', Validators.required] : [''],
      quarter: this.reportType == TaxReportType.UK || this.reportType == TaxReportType.OSS ? ['', Validators.required] : [''],
      year: this.reportType == TaxReportType.UK || this.reportType == TaxReportType.OSS ? ['', Validators.required] : [''],
      taxReportFile: ['', Validators.required],
    });
  }

  generateYearList() {
    const currentYear = new Date().getFullYear();
    for (let i = currentYear; i >= currentYear - 10; i--) {
      this.availableYears.push(i);
    }
  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: any) {
    const ctrlValue =
      this.addReportForm.get('monthYear')?.value || moment();
    ctrlValue.month(normalizedMonth.month()).year(normalizedMonth.year());
    this.addReportForm.get('monthYear')?.setValue(ctrlValue.clone());
    datepicker.close();
  }

  getListOfCountries() {
    if( this.reportType === TaxReportType.Regular || this.reportType === TaxReportType.Purchases) {
      this.constSvc.getVatCountries().subscribe((data) => {
        if (!data) return;
        this.fullCountriesList = data;
      });
    }
  }

  getPartnerList() {
    this.partnerService.getPartnersList().subscribe((result) => {
      this.partnerList = result;
    });
  }

  getCompanyList(page: number = this.previousPageCompany + 1, limit: number = 99999): void {
    // if (!this.partnerId) return;
    this.companyService.getCompanyList(limit, page, '')
      .subscribe((data) => {
        if (!data) return;
        if (data.meta.currentPage > 1) {
          this.companyList = [...this.companyList, ...data.items];
        } else {
          this.companyList = data.items;
        }
        this.previousPageCompany = data.meta.currentPage;
      this.totalPageCompany = data.meta.totalPages;
      });
  }

  getPartnerCompanyList(page: number = this.previousPageCompany + 1, limit: number = 99999): void {
    this.partnerService.getCustomListByPartner(limit, page, '', this.partnerId).subscribe(data => {
      if (!data) return;
      if (data.meta.currentPage > 1) {
        this.companyList = [...(this.companyList ?? []), ...data.items];
      } else {
        this.companyList = data.items;
      }
      this.previousPageCompany = data.meta.currentPage;
      this.totalPageCompany = data.meta.totalPages;
    });
  }

  fileUploadDoc(e: Event): void {
    const file: File = (e.target as HTMLInputElement).files![0];
    if (!file) return;

    const validTypes = [
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-excel',
    ];

    if (!validTypes.includes(file.type)) {
      this.notify.showError('Only .xlsx or .xls files are allowed');
      this.addReportForm.get('taxReportFile')?.setValue('');
      this.selectedFileName = '';
      return;
    }

    this.selectedFileName = file.name;
    this.addReportForm.get('taxReportFile')?.setValue(file);
  }

  onClickCreate(): void {
    this.showLoader = true;

    if (this.addReportForm.valid) {
      let reportMonth: string | null = null;
      let reportYear: string | null = null;
      let reportQuarter: string | null = null;
      let isQuarterly: boolean = false;

      if (this.reportType === TaxReportType.Regular || this.reportType === TaxReportType.Purchases || this.reportType === TaxReportType.IOSS) {
        isQuarterly = false;
        reportMonth = this.addReportForm.value.monthYear?.format('MM');
        reportYear = this.addReportForm.value.monthYear?.format('YYYY');
      } else if (this.reportType === TaxReportType.UK || this.reportType === TaxReportType.OSS) {
        isQuarterly = true;
        reportQuarter = this.addReportForm.value.quarter;
        reportYear = this.addReportForm.value.year;
      }

      const body = {
        type: this.reportType,
        partnerId: this.addReportForm.value.partner,
        customerId: this.addReportForm.value.customer,
        countryCode: this.addReportForm.value.country,
        reportMonth,
        reportYear,
        isQuarterly,
        reportQuarter,
        file: this.addReportForm.value.taxReportFile,
      };

      if (this.btnText === 'Upload') {
        const dialogRef = this.dialog.open(ConfirmPopupDialog);
        dialogRef.componentInstance.message = `Are you sure you want to upload Tax report?`;
        dialogRef.componentInstance.rightBtnText = 'Confirm';
        dialogRef.afterClosed().subscribe((value) => {
          if (!value) {
            this.showLoader = false;
            return;
          }
          this.reportedTaxReportService.createReportedTaxReport(body).subscribe(
            (result) => {
              this.showLoader = false;
              this.dialogRef.close({
                result,
                message: 'Report added successfully',
              });
            },
            (error) => {
              this.showLoader = false;
              if (
                error.error.message ===
                'Reported Tax report with the same parameters already exists'
              ) {
                this.message =
                  'Reported Tax report with the same parameters already exists. Do you want to replace it?';
                this.btnText = 'Replace';
              } else {
                this.dialogRef.close(error);
              }
            }
          );
        });
      } else {
        const dialogRef = this.dialog.open(ConfirmPopupDialog);
        dialogRef.componentInstance.message = `Are you sure you want to replace Tax report? This action is not recoverable.`;
        dialogRef.componentInstance.rightBtnText = 'Replace';
        dialogRef.afterClosed().subscribe((value) => {
          if (!value) {
            this.showLoader = false;
            return;
          }
          this.replaceReport(body);
        });
      }
    } else {
      this.addReportForm.markAllAsTouched();
      this.showLoader = false;
    }
  }

  replaceReport(body: any) {
    this.showLoader = true;
    this.reportedTaxReportService.createReportedTaxReport(body, true).subscribe(
      (result) => {
        this.showLoader = false;
        this.dialogRef.close({
          result,
          message: 'Report replaced successfully',
        });
      },
      (error) => {
        this.showLoader = false;
        this.dialogRef.close(error);
      }
    );
  }

  onClickClose(): void {
    this.dialogRef.close();
  }

  getFlagClass(code: string) {
    return `iti__${code?.toLowerCase()}`;
  }
}
